
import React from "react";
import { useTheme } from '~/ui/styled'
import { observer } from "mobx-react-lite";
import { StartFlex, BetweenFlex, Text, Button, IconFont } from "~components/El"
import { Avatar } from "~widgets/avatar"
const MemberItemContent: React.FC<{member: any, onClick: () => void}> = ({ member, onClick}) => {
    const theme = useTheme()
    return (
        <Button
            width="100%"
            border={`1px solid ${theme.colors.primary}`}
            borderRadius="8px"
            bg="rgba(7, 193, 96, 0.1)"
            onClick={onClick}
        >
            <BetweenFlex
                height="auto"
                width="100%"
                padding="15px 12px"
            >
                <StartFlex height="auto">
                    <Avatar avatar={member.user.avatar} name={member.user.name} />
                    <StartFlex width={'auto'} ml="12px">
                        <Text fontSize="14px" color={theme.colors.text}>{member.user.name}</Text>
                    </StartFlex>
                </StartFlex>
                <IconFont name={"close"} size={9} color={theme.colors.primary} />
            </BetweenFlex>
            
        </Button>
    )
}

export default observer(MemberItemContent)
